import { useState, useEffect } from "react";
import { StyledButtonMintNft } from "../../../styles";
import { useMintarNft } from '../MintarNFT';
import { ShowNftInfoButton } from "../ExibeNFT";
import { blockchainService } from "../../../../../services/blockchainService";

export default function MintButton({ merge, headers, project_id, modelo_GUID, setdocMap }) {
  const { mintarNft } = useMintarNft();
  const [isMinted, setIsMinted] = useState(false);

  useEffect(() => {
    const checkIfMinted = async () => {
      try {
        const response = await blockchainService.checkMergeMinted(merge.id, headers);
  
        const minted = response.data?.is_minted === true;
  
        setIsMinted(minted);
  
      } catch (error) {
        console.error("Erro ao verificar NFT:", error);
        setIsMinted(false);
      }
    };
  
    checkIfMinted();
  }, [merge.id, headers]);
  

  if (merge.is_cancelado) return null;

  return !isMinted ? (
    <StyledButtonMintNft
      style={{ float: "left", marginLeft: "5px" }}
      onClick={async () => {
        await mintarNft(
          merge.id,
          merge.file_name,
          merge.topic_document,
          merge.path,
          project_id,
          modelo_GUID,
          headers,
          setdocMap
        );

        // Atualizar estado local
        setIsMinted(true);
      }}
    >
      Mint NFT
    </StyledButtonMintNft>
  ) : (
    <ShowNftInfoButton mergeId={merge.id} />
  );
}
